import { Card, CardContent } from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import { WStateLayout } from '@wareclouds/wareclouds-ui';
import { useTranslation } from 'react-i18next';

export default function EnabledRouteError() {
  const { t } = useTranslation(['description']);

  return (
    <Card variant="outlined" elevation={0} sx={{ borderRadius: 4 }}>
      <CardContent>
        <WStateLayout
          description={t('routes.enabled.error_description')}
          title={t('routes.enabled.error_title')}
        >
          <ReportIcon sx={{ fontSize: 100 }} color="error" />
        </WStateLayout>
      </CardContent>
    </Card>
  );
}
